import { TechdocsCardProps } from '../../lib/types';
import { useTechDocsLink } from '../../lib/hooks';
import { BaseEntityCard } from '../base-entity-card';

export const TechDocsCard = (props: TechdocsCardProps) => {
  const { entity } = props;
  const { techDocsLink } = useTechDocsLink(entity ?? null);

  return (
    <BaseEntityCard
      {...props}
      getActionRoute={() => techDocsLink()}
      defaultActionLabel="Read"
    />
  );
};
